import { FileCommand } from 'app/projects/core/src/lib/models/file.command';

export class UploadZipCommand extends FileCommand {
    constructor(file: File) {
        super('file', file);

        this.formData.append('is_manual', 'true');
    }
}
